module.exports = __webpack_public_path__ + "img/empty.2c8425da.png";